export const isFlexVariant = (prest) => {
    return prest['pvFlex'] === "flex"
}


export const isNonflexVariant = (prest) => {
    return prest['pvFlex'] === "nonflex"
}


export const isPierreVacance = (prest) => {
    return isFlexVariant(prest) || isNonflexVariant(prest)
}